import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const POWER_TOWERS_AND_CABLES: Layer = {
  id: ConstraintsCategory.POWER,
  layerType: ConstraintsLayerType,
  title: "Power towers, lines & cables",
  requiredFeatureAccess: [Feature.powerLayer],
  toggleable: true,
  group: LayerGroup.POWER,
  icon: "lt-flashlight-line",
  description: "Towers, lines and cables",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  layerConfig: {
    showTitle: true,
    disableHatch: true,
    rootCategory: ConstraintsCategory.POWER,
    layerRoots: ["power_cables", "power_overhead_lines", "power_towers"],
    dedupePoints: false,
    categorySchema: [{ key: "power_cables" }, { key: "power_overhead_lines" }, { key: "power_towers" }],
    attributesToLoad: ["voltage_class"],
    attributeFilters: [
      {
        attribute: "voltage_class",
        options: [
          { value: "Transmission", display_name: "Transmission (>132kV)" },
          { value: "Extra High Voltage (EHV)", display_name: "Extra High Voltage (33-132kV)" },
          { value: "High Voltage (HV)", display_name: "High Voltage (1-32kV)" },
          { value: "Low Voltage (LV)", display_name: "Low Voltage (<1kV)" },
          { value: "Unknown", display_name: "Unknown" },
        ],
      },
    ],
    displayBy: {
      showDropdown: false,
      defaultDisplayBy: "voltage_class",
    },
  },
};
